import { V2 } from '@eventr/common'
import { ColoursObj, Icon, TEventrIcons } from '@eventr/common-storybook'
import { Stack } from '@mui/material'
import { DisclosureGroup } from '../../../../common/DisclosureGroup'
import { renderComponents } from '../../../v2Utils'

interface ICardDTProps {
    data: V2
    screenType: string
}

export const CardDT = ({ data, screenType }: ICardDTProps) => {
    return (
        <DisclosureGroup
            stickyHeader
            title={data.sectionDisplayName}
            containerStyle={{
                backgroundColor: ColoursObj.backgrounds.primary,
            }}
            icon={
                <Icon
                    name={
                        (data.rendererOptions?.settings
                            ?.headerIcon as TEventrIcons) ?? 'Activity'
                    }
                    iconColour={ColoursObj.core.primary}
                />
            }
            content={
                <Stack padding="16px" bgcolor="#F5F9FA" borderRadius="8px">
                    {renderComponents(
                        data.data,
                        data.rendererOptions?.components ?? []
                    )}
                </Stack>
            }
            isOpen={true}
        />
    )
}
